module.exports = __webpack_public_path__ + "img/9.99a03c84.jpg";